/**
 * Kategórie stránky Nastavenia (KOLO 170).
 *
 * User: *„teraz musím skrolovať úplne dole, aby som sa k dačomu dostal"* —
 * dvadsať kariet pod sebou je rozdelených do siedmich kategórií v ľavom
 * menu. Kategória je v adrese (`?kategoria=`), takže odkaz z inej časti
 * appky otvorí rovno správne miesto; adresa sa skladá len tu.
 */

export const KATEGORIE = [
  {
    kluc: "ceny",
    nazov: "Ceny a cenníky",
    popis: "DPH, cenníky dodávateľov, úprava cien, eshopy",
  },
  {
    kluc: "hrany",
    nazov: "Hrany",
    popis: "Nadmiera hrany, predfrez, hrany pre dekor",
  },
  {
    kluc: "dielce",
    nazov: "Dielce a dosky",
    popis: "Hrúbky dosiek, lepené dielce, názvy dielcov",
  },
  {
    kluc: "vyroba",
    nazov: "Výroba a CNC",
    popis: "Výrobné postupy, minimum upnutia CNC",
  },
  {
    kluc: "rezanie",
    nazov: "Rezanie",
    popis: "Porez tabúľ, zvyšky, nárezový plán tyčí",
  },
  {
    kluc: "topsolid",
    nazov: "TopSolid",
    popis: "Zapamätané priradenia, pracovné dosky",
  },
  {
    kluc: "prepojenia",
    nazov: "Prepojenia",
    popis: "Kľúč pre Tandem Zostavy, pomocník pre Cut Rite, odrezky pri píle",
  },
] as const;

export type KategoriaNastaveni = (typeof KATEGORIE)[number]["kluc"];

export const PREDVOLENA_KATEGORIA: KategoriaNastaveni = "ceny";

/** Kľúč z adresy → kategória; neznámy alebo chýbajúci → predvolená. */
export function kategoriaZAdresy(hodnota: string | null): KategoriaNastaveni {
  return KATEGORIE.find((k) => k.kluc === hodnota)?.kluc ?? PREDVOLENA_KATEGORIA;
}

/** Adresa kategórie Nastavení — odkazy z appky ju nepíšu ručne. */
export function odkazNaNastavenia(kategoria: KategoriaNastaveni): string {
  return `/nastavenia?kategoria=${kategoria}`;
}
